import {Link} from 'react-router-dom';
import {ChevronRight} from 'lucide-react';
import type {ReactNode} from 'react';

type Props = {
  /** The trail after "Quotes", e.g. the request id on a request page. */
  readonly crumb?: string;
  readonly actions?: ReactNode;
};

/**
 * The upper header for the generic quote pages. `/quotes` is chromeless (the AES desk
 * draws its own ribbon there), so the app `Header` that `PageHeader` portals into is
 * absent; this bar mirrors its height, surface and uppercase title so the pages read
 * like every other MATIC page.
 */
export function QuotesHeaderBar({crumb, actions}: Props) {
  return (
    <header className="relative z-10 flex h-16 shrink-0 items-center justify-between gap-4 border-b border-neutral-200 bg-white px-6 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.08)]">
      <nav
        aria-label="Breadcrumb"
        className="flex min-w-0 items-center gap-2 text-neutral-900"
      >
        {crumb ? (
          <>
            <Link
              to="/quotes"
              className="text-xl font-bold uppercase leading-none tracking-tight text-neutral-900 no-underline hover:text-neutral-600"
            >
              Quotes
            </Link>
            <ChevronRight
              className="h-4 w-4 shrink-0 text-neutral-400"
              aria-hidden
            />
            <span className="truncate text-sm font-medium text-neutral-500">
              {crumb}
            </span>
          </>
        ) : (
          <h1 className="text-xl font-bold uppercase leading-none tracking-tight text-neutral-900">
            Quotes
          </h1>
        )}
      </nav>
      {actions && (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      )}
    </header>
  );
}
